module.exports = [{"key":"1","name":"非标1","icon":"","editTime":"2017-11-11","canEdit":false},{"key":"2","name":"非标2","icon":"","editTime":"2017-11-11","canEdit":false}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/datas_other.json
// module id = 537
// module chunks = 0